import React from "react";
import { Inbox, Search, FileText } from "lucide-react";

// Verbatim empty-state copy from v19 (paymentposting context).
export function PostingEmptyState({ variant = "empty", onImport }) {
  if (variant === "filter") {
    return (
      <div className="pp-empty-state" data-testid="pp-empty-filter">
        <div className="pp-eic"><Search size={25} strokeWidth={1.7} /></div>
        <h3>No checks match these filters</h3>
        <p>Try widening the date range, clearing a status, or removing a filter chip above.</p>
      </div>
    );
  }
  return (
    <div className="pp-empty-state" data-testid="pp-empty-state">
      <div className="pp-eic"><Inbox size={25} strokeWidth={1.7} /></div>
      <h3>No checks or ERAs to post yet</h3>
      <p>
        Drop your first paper EOB, check, or 835 ERA — Lens reads the remittance, matches every line to the
        right claim, interprets each CARC code, and auto-posts what it can. Only true exceptions come to you.
      </p>
      <div className="pp-ecta">
        <button onClick={onImport} data-testid="pp-empty-import" className="pp-btn pp-dark">
          <FileText size={14} /> Import an EOB
        </button>
      </div>
    </div>
  );
}
